import { Text, Flex, Button, Modal } from '@mantine/core';

interface ConfirmModalProps {
  title: string;
  isOpen: boolean;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  colorSchema?: string;
  confirmButtonTitle: string;
}

const ConfirmModal = ({
  title,
  isOpen,
  description,
  onClose,
  isLoading,
  onConfirm,
  colorSchema,
  confirmButtonTitle
}: ConfirmModalProps) => {
  return (
    <Modal
      opened={isOpen}
      radius="sm"
      withCloseButton
      onClose={onClose}
      centered
      title={title}
      size="sm"
      zIndex={10000}
    >
      <Text c="gray.7" fz="sm" mb="24">
        {description}
      </Text>
      <Flex align="center" gap="16" justify="flex-end">
        <Button onClick={onClose} variant="default" disabled={isLoading}>
          Cancel
        </Button>
        <Button loading={isLoading} color={colorSchema} onClick={onConfirm}>
          {confirmButtonTitle}
        </Button>
      </Flex>
    </Modal>
  );
};

export default ConfirmModal;
